export const RunSliderDots = (el :HTMLElement,autoScroll: number | null| undefined) => {
    //const animDuration = 600;
    //console.log('elSlider el: ',el);
    // const id = el.getAttribute("id");
    el.addEventListener('touchstart', handleTouchStart, false);
    el.addEventListener('mousedown', handleTouchMouseStart, false);
    el.addEventListener('mouseup', handleTouchMouseEnd, false);
    el.addEventListener('touchmove', handleTouchMove, false);
    el.addEventListener('touchend', handleTouchEnd, false);

    //console.log(`RunSliderDots.el: ${id}`, el);

    const slider = el;
    const dots: any = slider.querySelector(".dots");
    const sliderImgs: any = slider.querySelectorAll(".img");

    let currImg = 0;
    let prevImg = sliderImgs.length - 1;

    // Creates dots and add listeners to them
    for (let i = 0; i < sliderImgs.length; ++i) {
        const dot = document.createElement("div");
        dot.classList.add("dot");
        dots.appendChild(dot);
        dot.addEventListener("click", dotClick.bind(null, i), false);
    }
    const allDots = dots.querySelectorAll(".dot") as HTMLElement[];
    allDots[0].classList.add("active-dot");

    sliderImgs[0].style.left = "0";
    let refreshIntervalId: NodeJS.Timer;
    if(autoScroll)
        refreshIntervalId = setInterval(runAutoScroll, autoScroll);
    function runAutoScroll( )
    {
        const allDots = dots.querySelectorAll(".dot") as HTMLElement[];
        for (let i = 0; i < allDots.length; ++i) {
            const dot = allDots[i];
            if((i+1) === allDots.length) {
                //allDots[0].click();
                dotAutoScroll(0);
                return false;
            }
           else if(dot.classList.contains("active-dot")){
               //allDots[i+1].click();
                dotAutoScroll(i+1);
               return false;
           }

        }

    }

    /**
     * Animates images
     * @param {number} [nextImg] - index of next image to show
     * @param {boolean} [right = false] - animate to right
     */
    function animateSlider(nextImg: number, right: boolean) {
        //console.log(`nextImg:${nextImg}, right:${right}`);
        if(nextImg === 0 || nextImg > sliderImgs.length)
            return;
        curDotNumber = nextImg;
        if (!nextImg)
            nextImg = currImg + 1 < sliderImgs.length ? currImg + 2 : 1;

        --nextImg;
        sliderImgs[prevImg].style.animationName = "";

        //console.log(`nextImg:${nextImg}`);
        if (!right) {
            sliderImgs[nextImg].style.animationName = "leftNext";
            sliderImgs[currImg].style.animationName = "leftCurr";
        } else {
            sliderImgs[nextImg].style.animationName = "rightNext";
            sliderImgs[currImg].style.animationName = "rightCurr";
        }

        prevImg = currImg;
        currImg = nextImg;

        const currDot = allDots[currImg];
        currDot.classList.add("active-dot");
        const prevDot = allDots[prevImg];
        prevDot.classList.remove("active-dot");
    }
    function removeLeftFromStyle(){
        if (sliderImgs[0].style.left === "0px") {
            sliderImgs[0].style.left = null;
        }
    }
    function dotAutoScroll(num: number) {
        //console.log('dotAutoScroll: aasas',num);
        removeLeftFromStyle();

        if (num === currImg)
            return false;

        if (num > currImg)
            animateSlider(num + 1, false);
        else
            animateSlider(num + 1, true);

    }
    /**
     * Decides if animate to left or right and highlights clicked dot
     * @param {number} num - index of clicked dot
     */
    function dotClick(num: number) {
        //console.log('dotClick: aasas',num);
        clearInterval(refreshIntervalId);
        removeLeftFromStyle();

        if (num === currImg)
            return false;

        if (num > currImg)
            animateSlider(num + 1, false);
        else
            animateSlider(num + 1, true);

    }


    var xDown: any = null;
    var yDown: any = null;

    var xDownEnd: any = null;
    var yDownEnd: any = null;

    var curDotNumber: number = 1;

    function getTouches(evt: any) {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt: any) {
        //evt.preventDefault();
        //console.log('handleTouchStart');
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleTouchMouseStart(evt: any) {
        evt.preventDefault();
        //console.log('handleTouchMouseStart',evt);
        xDown = evt.clientX;
        yDown = evt.clientY;
    };

    function handleTouchMouseEnd(evt: any) {
        evt.preventDefault();
        //console.log('handleTouchMouseEnd',evt);
        if (xDown < evt.clientX) {
            //console.log('mouse swap right');
            if(curDotNumber > 1) {
                clearInterval(refreshIntervalId);
                removeLeftFromStyle();
                animateSlider(curDotNumber - 1, true);
            }

        }
        if (xDown > evt.clientX) {
            //console.log(`mouse swap left curDotNumber:${curDotNumber}`,sliderImgs.length);
            if(curDotNumber < sliderImgs.length) {
                clearInterval(refreshIntervalId);
                removeLeftFromStyle();
                animateSlider(curDotNumber + 1, false);
            }
        }
        //xDown = 0;
        //yDown = 0;
    };

    function handleTouchMove(evt: any) {
        //console.log('handleTouchMove');
        if (!xDown || !yDown) {
            return;
        }

        xDownEnd = evt.touches[0].clientX;
        yDownEnd = evt.touches[0].clientY;
    };
    function handleTouchEnd(evt: any) {
        //console.log(`handleTouchEnd xDown:${xDown} / xDownEnd:${xDownEnd}, yDown:${yDown} / yDownEnd:${yDownEnd}`);
        if (!xDownEnd || !yDownEnd) {
            return;
        }

        // const xDiff = xDown - xDownEnd;
        // const yDiff = yDown - yDownEnd;

        if (Math.abs(xDown) > Math.abs(xDownEnd)) {/*most significant*/

                /* left swipe */
                //console.log('left swipe',curDotNumber);
                if(curDotNumber < sliderImgs.length) {
                    clearInterval(refreshIntervalId);
                    removeLeftFromStyle();
                    animateSlider(curDotNumber + 1, false);
                }

        } else {
            /* right swipe */
            //console.log('right swipe');
            if(curDotNumber > 1) {
                clearInterval(refreshIntervalId);
                removeLeftFromStyle();
                animateSlider(curDotNumber - 1, true);
            }
        }
        xDownEnd = null;
        yDownEnd = null;
    }
}